import * as React from "react";

import { constants } from "@common/_constants";
import { Helmet } from "react-helmet";

interface HeaderProps {
    title?: string;
}

export const Header: React.SFC<HeaderProps> = props => {
    const title = !!props.title ? `${props.title} | relode` : "relode";
    return (
        <Helmet>
            {props.title && <title>{title}</title>}
        </Helmet>
    );
};

export default Header;
